import {
  IconBeerAndWine,
  IconCardholder18,
  IconCardholder21,
  IconChildrensArea,
  IconClothesPress,
  IconComputers,
  IconConfRooms,
  IconFlightMonitors,
  IconGym,
  IconNewspapersAndMagazines,
  IconNoSmoking,
  IconPremiumDrinks,
  IconPremiumFood,
  IconPrintersAndCopiers,
  IconPrivateRooms,
  IconShoeShine,
  IconShowers,
  IconSmokingAreas,
  IconSnacks,
  IconSpaServices,
  IconTablets,
  IconTelephones,
  IconTV,
  IconWiFi,
} from '../components/icons';

export const amenityIdToIconMap = {
  '18_CARDHOLDER': IconCardholder18,
  '21_CARDHOLDER': IconCardholder21,
  'NON-SMOKING': IconNoSmoking,
  BEER_WINE_FREE: IconBeerAndWine,
  BEER_WINE: IconBeerAndWine,
  CHILDREN_ROOMS: IconChildrensArea,
  CLOTHES_PRESS: IconClothesPress,
  CONFERENCE_ROOMS_FREE: IconConfRooms,
  CONFERENCE_ROOMS: IconConfRooms,
  FLIGHT_MONITORS: IconFlightMonitors,
  INTERNET_TERMINALS: IconComputers,
  NEWSPAPERS: IconNewspapersAndMagazines,
  PREMIUM_FOOD_FREE: IconPremiumFood,
  PREMIUM_FOOD: IconPremiumFood,
  PRINTERS_FREE: IconPrintersAndCopiers,
  PRINTERS: IconPrintersAndCopiers,
  PRIVATE_ROOMS_FREE: IconPrivateRooms,
  PRIVATE_ROOMS: IconPrivateRooms,
  SHOWERS_FREE: IconShowers,
  SHOWERS: IconShowers,
  SNACKS_FREE: IconSnacks,
  SNACKS: IconSnacks,
  SPA_FREE: IconSpaServices,
  SPA: IconSpaServices,
  SPIRITS_LIQUOR_FREE: IconPremiumDrinks,
  SPIRITS_LIQUOR: IconPremiumDrinks,
  TELEPHONES: IconTelephones,
  TV: IconTV,
  WIFI_FREE: IconWiFi,
  WIFI: IconWiFi,
  LOUNGEBUDDY_CHECKIN: IconTablets,
  CLOTHES_PRESS_FREE: IconClothesPress,
  GYM_FREE: IconGym,
  GYM: IconGym,
  SHOE_SHINE: IconShoeShine,
  SMOKING_ROOMS: IconSmokingAreas,
};
